var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3.226A1.613 1.613 0 1 0 10 0a1.613 1.613 0 0 0 0 3.226M4.07 5.682a1.613 1.613 0 1 0 0-3.226 1.613 1.613 0 0 0 0 3.226m14.317 5.93a1.613 1.613 0 1 0 0-3.225 1.613 1.613 0 0 0 0 3.226m-16.774 0a1.613 1.613 0 1 0 0-3.225 1.613 1.613 0 0 0 0 3.226m14.318 5.931a1.613 1.613 0 1 0 0-3.225 1.613 1.613 0 0 0 0 3.225m-11.862 0a1.613 1.613 0 1 0 0-3.225 1.613 1.613 0 0 0 0 3.225M10 20a1.613 1.613 0 1 0 0-3.226A1.613 1.613 0 0 0 10 20"
  })));
};
export default SvgSpinner;